var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[(_vm.accountId)?_c('account-edit',{attrs:{"id":_vm.accountId},on:{"close":_vm.closeModal}}):_c('account-add',{on:{"save-success":_vm.createdAndClose,"close":_vm.closeModal}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }